import React from "react"
import Button from "../../../../../../lib/common/blocks/button/Button"
import { Link } from "gatsby"
import { site } from "../../../../../../../utils/site"

const MegaMenuSearchResultsCol = ({
  label,
  count,
  data,
  linkLabel,
  linkLabelEmpty,
  url, 
  articleUrl,
  term,
}) => {

  const searchTerm = term !== null ? term : ""
  const articleRhUrl = linkLabel === "Voir les articles" ? articleUrl : url+searchTerm
  return (
    <div className="w-50">
      <div className="flex justify-content-space-between align-items-center pin-3">
        <div className="relative">
          <strong className="fs-24">{label}</strong>
          <sup className="nbPostes ml-1 fs-14">
            <Button
              aspect="classique"
              color="primary"
              size="small"
              className="border-radius-5 fs-14"
              to={site === "rh" ? articleRhUrl : url+searchTerm}
            >
              {count}
            </Button>
          </sup>
        </div>
        <Button
          aspect="link"
          color="secondary"
          size="small"
          className="underline"
          to={site === "rh" ? articleRhUrl : url}
        >
          {count === 0 ? linkLabelEmpty : linkLabel}
        </Button>
      </div>
      <ul>
        {data?.map((d) => {
          return (
            <li className="pbl-1 pin-3 searchResultItem">
              <Link
                to={d.route}
                className="fs-24"
                style={{
                  display: "-webkit-box",
                  webkitLineClamp: "2",
                  webkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {d.title}
              </Link>
              <Link
                to="/"
                className="fs-16"
                style={{
                  display: "-webkit-box",
                  webkitLineClamp: "2",
                  webkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {d.description}
              </Link>
            </li>
          )
        })}
        {count === 0 && (
          <ul>
            <li className="pbl-2 pin-3">
              <p className="fs-24">Aucun résultat</p>
              <span>
                Mais vous pouvez toujours faire une nouvelle recherche
              </span>
            </li>
          </ul>
        )}
      </ul>
    </div>
  )
}

export default MegaMenuSearchResultsCol
